const TYPE_ENTRE_CHEVRONS = '1';
const TYPE_SOUS_CHEVRONS = '2';
const TYPE_ADHESIF = '3';
const TYPE_MANCHON = '4';
const TYPE_SUSPENTE = '5';
const TYPE_MEMBRANE = '7';
const TYPE_MASTIC = '8';
const TYPE_INSULATOR = '9';
const TYPE_SUPPORT = '10';
const TYPE_PASTILLE = '11';
const TYPE_SOLIVE = '12';
const TYPE_SECOND = '13';
const TYPE_BLOWN = '14';

const filterProducts = (apiResponse, productType) => {
  const tab = (apiResponse.data || {}).products || [];
  let options = tab.filter(x => (x.productstype || []).indexOf(productType) > -1);
  options = options.map(x => ({
    text: x.name,
    key: x.id,
    value: x,
  }));
  return options;
};

const getInsulatorOptions = apiResponse => filterProducts(apiResponse, TYPE_INSULATOR);

const getSupportOptions = apiResponse => filterProducts(apiResponse, TYPE_SUPPORT);

const getEntreChevronsOptions = apiResponse => filterProducts(apiResponse, TYPE_ENTRE_CHEVRONS);

const getSousChevronsOptions = apiResponse => filterProducts(apiResponse, TYPE_SOUS_CHEVRONS);

const getAdhesifOptions = apiResponse => filterProducts(apiResponse, TYPE_ADHESIF);

const getMembraneOptions = apiResponse => filterProducts(apiResponse, TYPE_MEMBRANE);

const getSuspentesOptions = apiResponse => filterProducts(apiResponse, TYPE_SUSPENTE);

const getManchonOptions = apiResponse => filterProducts(apiResponse, TYPE_MANCHON);

const getMasticOptions = apiResponse => filterProducts(apiResponse, TYPE_MASTIC);

const getPastilleOptions = apiResponse => filterProducts(apiResponse, TYPE_PASTILLE);

const getInsulatorBetween = apiResponse => filterProducts(apiResponse, TYPE_SOLIVE);

const getInsulatorSecond = apiResponse => filterProducts(apiResponse, TYPE_SECOND);

const getInsulatorBlown = apiResponse => filterProducts(apiResponse, TYPE_BLOWN);

const getAllOptions = res => ((res.data || {}).products || []).map(x => ({
  text: x.name,
  key: x.id,
  value: x,
}));


export default {
  getAdhesifOptions,
  getAllOptions,
  getEntreChevronsOptions,
  getInsulatorOptions,
  getManchonOptions,
  getMasticOptions,
  getMembraneOptions,
  getPastilleOptions,
  getSousChevronsOptions,
  getSupportOptions,
  getSuspentesOptions,
  getInsulatorBetween,
  getInsulatorSecond,
  getInsulatorBlown,
};



// WEBPACK FOOTER //
// ./src/services/ProductService.js